import {
  Button,
  Typography,
  Box,
  Dialog,
  DialogTitle,
  IconButton,
  DialogContent,
  DialogActions,
} from '@mui/material';
import { CloseRounded, LocationOnOutlined } from '@mui/icons-material';
import { Site } from '@/gql/graphql';

interface ContactSupportDialogProps {
  open: boolean;
  site: Site | undefined;
  onClose: () => void;
  onConfirm: () => void;
  loading: boolean;
}

const ContactSupportDialog = ({
  open,
  site,
  onClose,
  onConfirm,
  loading,
}: ContactSupportDialogProps) => {
  return (
    <Dialog open={open} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Typography variant="h4">Confirm selection</Typography>
        <IconButton onClick={onClose}>
          <CloseRounded />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Typography variant="body1">
          Verify the details below match your specific site or department:
        </Typography>
        {site && (
          <Box display="flex" mt={1}>
            <Box display="flex" alignItems="center" mr={1.5}>
              <LocationOnOutlined />
            </Box>
            <Box>
              <Typography variant="h6" sx={{ fontWeight: 600 }}>
                {site.name}
              </Typography>
              <Typography variant="body1">{site.organization}</Typography>
              <Typography variant="body2">
                {site.address1}
                {site.address2 ? ` , ${site.address2}, ` : ', '}
                {site.location?.city}, {site.location?.stateProvince}, {site.location?.postalCode}
              </Typography>
            </Box>
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        <Button
          onClick={(e) => {
            e.stopPropagation();
            onClose();
          }}
          variant="text">
          Cancel
        </Button>
        <Button variant="contained" onClick={onConfirm} color="primary" disabled={loading}>
          This is my site
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ContactSupportDialog;
